export const FILTER_SHOW_ALL_SLUG = 'showAll'

export const FILTER_SPECIALIZATION_SLUG = 'specialization'
export const FILTER_TRAINING_SLUG = 'training'
export const FILTER_TIMES_SLUG = 'times'
export const FILTER_DAYS_SLUG = 'days'
export const FILTER_INSURANCE_SLUG = 'insurance'
export const FILTER_LANGUAGE_SLUG = 'language'
export const FILTER_IN_DAYS_COUNT = 'availability'
export const FILTER_SESSION_TYPE_SLUG = 'sessionType'
export const FILTER_SESSION_LOCATION_SLUG = 'sessionLocation'

export const FILTER_SEARCH_SLUG = 'search'

// see https://stackoverflow.com/a/45486495 for as const explanation
export const FILTER_ALL_SLUGS = [
  FILTER_SPECIALIZATION_SLUG,
  FILTER_SESSION_TYPE_SLUG,
  FILTER_SESSION_LOCATION_SLUG,
  FILTER_INSURANCE_SLUG,
  FILTER_TRAINING_SLUG,
  FILTER_TIMES_SLUG,
  FILTER_DAYS_SLUG,
  FILTER_IN_DAYS_COUNT,
  FILTER_LANGUAGE_SLUG,
  FILTER_SEARCH_SLUG,
] as const
